/* eslint-disable no-undef */
import router from './router';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import { Message } from 'element-ui';
import { getToken } from '~/utils/auth';
import { post } from '~/utils/request';
import global from '~/components/Global';
import Cookies from 'js-cookie';

import shared from './shared';
import store from './store';

const marketList = ['/previewresume4mail'];     //营销页面

router.beforeEach(async (to, from, next) => {
  NProgress.start();
  if (_hmt) {
    if (to.path) {
      _hmt.push(['_trackPageview', '/#' + to.fullPath]);
    }
  } 
  if(marketList.indexOf(to.path.toLowerCase()) !== -1){
    await demoLogin().then(m => {
      if(m.errcode === 0){
        var user = m.data;
        store.dispatch('Login', user);
      }
    });    
    next();
    return;
  } else {
    if(store.getters.userId == 8){
      store.dispatch('Logout');
    }
  }

  if(to.path && to.meta){
    if(to.meta.requiresAuth){
      var token = getToken();    
      if(token){
        next();
        return;
      } else {
        Message.error('您还未登录，请登录后再试');
        next('/');
        NProgress.done();
        return;
      }
    }

    var roleId = store.getters.roleId;
    if(to.meta.userRole == 'hr'){      
      if(roleId == 2){
        next();
      } else {
        Message.error('没有权限访问，请重试或联系管理员');
        NProgress.done();
        return;     
      }
    }
    if(to.meta.userRole == 'me'){      
      if(roleId == 1){
        next();
      } else {
        Message.error('没有权限访问，请重试或联系管理员');
        NProgress.done();
        return;       
      }
    }
  }   
  next();
});

router.afterEach((to, from) => {
  NProgress.done();
  var cookieIdKey = 'CookieId';
  var cookieId = shared.getCookieId(cookieIdKey);
  let userId = Cookies.get('UserID');
  if(!cookieId){
    cookieId = shared.s4() + shared.s4() + '-' + shared.s4() + '-' + shared.s4() + '-' + shared.s4() + '-' + shared.s4() + shared.s4() + shared.s4();
    shared.createCookie('CookieId', cookieId, 365);
  }

  let roleId = Cookies.get('RoleID');
  var signCode = global.ME_SIGNCODE;
  if(roleId == 2){
    signCode = global.HR_SIGNCODE;
  }

  let data = {
    type: 'visit',
    userId: userId ? userId : '0',
    cookieId: cookieId,
    signCode: signCode,  
    from: {
      name: from.name || '',
      path: from.path || '',
      fullPath: from.fullPath || ''
    },
    to: {
      name: to.name || '',
      path: to.path || '',
      fullPath: to.fullPath || ''
    }
  };  
  logEvent(data);
});

const logEvent = (params) => {
  post('/PageVisit/Add', params).then();
};

const demoLogin = async function() {
  return new Promise((resolve, reject) => {
    post('/Account/DemoLogin', {
      userName: 'demo',
      sign: global.HR_SIGNCODE 
    }).then(m => {
      resolve(m);
    }).catch(err => {
      reject(err);
    });
  });
};